<template>
    <div>
        <b-button
            v-if="
                shareholdersList.shareholdersDropdownList.length <= 0 &&
                !isShareholderFull
            "
            variant="primary"
            class="d-flex justify-content-center align-items-center"
            @click="openCreateShareholderForm"
        >
            <vector
                data-name="add-user"
                data-width="15px"
                data-height="12px"
                data-test="add-a-new-shareholder-btn"
                class="mr-.5 d-flex justify-content-center align-items-center"
            />
            Add a new shareholder
        </b-button>

        <b-dropdown
            v-if="
                shareholdersList.shareholdersDropdownList.length > 0 &&
                !isShareholderFull
            "
            id="dropdown-1"
            class="mt-.3"
            variant="primary"
            data-test="add-a-new-shareholder-dropdown"
        >
            <template #button-content>
                <div
                    class="
                        d-inline-flex
                        justify-content-center
                        align-items-center
                    "
                >
                    <vector
                        data-name="add-user"
                        data-width="15px"
                        data-height="12px"
                        class="
                            mr-.5
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    />
                    Add another shareholder
                </div>
            </template>

            <b-dropdown-item
                style="font-size: 1.2em"
                variant="primary"
                data-test="add-a-new-shareholder-manually"
                @click="openCreateShareholderForm"
            >
                Add a new shareholder manually
            </b-dropdown-item>

            <div
                v-if="
                    shareholdersList.shareholdersDropdownList &&
                    shareholdersList.shareholdersDropdownList.length >= 1
                "
            >
                <div class="dropdown-divider"></div>

                <b-dropdown-text class="text-ternary">
                    <span> Select one from the list </span>
                </b-dropdown-text>

                <b-dropdown-item
                    v-for="shareholder in shareholdersList.shareholdersDropdownList"
                    :key="shareholder.name + '_' + shareholder.email + '_' + shareholder._id"
                    class="text-primary text-uppercase"
                    variant="primary"
                    style="font-size: 1.2em" 
                    data-test="select-from-list"
                    @click="$emit('createShareholderFromDropdown', shareholder)"
                >
                    {{ shareholder.name }}
                </b-dropdown-item>
               
            </div>
        </b-dropdown>

        <loader
            v-if="isFetchingData"
            data-type="MinimumTaskList"
            class="mt-1 custom-loading"
        />

        <div v-else data-test="shareholders-list">
            <div
                v-for="shareholder in shareholdersList.shareholders"
                :key="shareholder.email + '_' + shareholder._id"
                class="mt-2"
            >
                <div
                    data-test="list-box-shareholder"
                    class="list-box mb-1 row align-items-center"
                    style="margin-left: 0.1em; margin-right: 0.1em"
                >
                    <div
                        class="
                            user
                            d-flex
                            align-items-center
                            col-lg-4
                            justify-content-lg-start justify-content-md-center
                            mb-md-0 mb-sm-1
                        "
                    >
                        <b-avatar
                            size="30"
                            :text="getAvatarInitial(shareholder.name)"
                            :variant="`light-primary`"
                        />

                        <h3 class="font-weight-bold p-0 m-0 ml-1 text-break">
                            {{ shareholder.name }}
                        </h3>
                    </div>

                    <p
                        class="
                            m-0
                            p-0
                            col-lg-5
                            text-right
                            align-items-center
                            text-sm-center
                            mb-md-0 mb-sm-1
                            text-lg-right
                        "
                    >
                        {{ shareholder.email }}
                    </p>

                    <div
                        data-test="actions"
                        class="
                            actions
                            mb-md-0
                            d-flex
                            justify-content-md-end
                            align-items-center
                            col-lg-3
                            justify-content-sm-center
                        "
                    >
                        <span
                            :class="[
                                'steps-status d-block mr-2',
                                getCompletedStepsOf(shareholder) ===
                                totalStepsOf(shareholder)
                                    ? 'text-success'
                                    : 'text-danger',
                            ]"
                        >
                            {{ getCompletedStepsOf(shareholder) }} / {{ totalStepsOf(shareholder) }}
                        </span>

                        <div
                            class="mr-2 cursor-pointer"
                            :data-test="`editShareholder-${shareholder.name}`"
                            @click="$emit('edit', shareholder, 'edit')"
                        >
                            <feather-icon size="21" icon="EditIcon" />
                        </div>

                        <div class="cursor-pointer">
                            <vector
                                data-type="icon"
                                data-name="cancel"
                                :data-test="`delete-${shareholder.name}`"
                                @click.native="$emit('remove', shareholder)"
                            ></vector>
                        </div>
                    </div>
                </div>
            </div>

            <!-- start nominee shareholder -->
                <!-- <div v-if="shareholdersList.nomineeShareholders.length > 0">
                    <h3 style="margin-top: 25px;">Nominee Shareholders</h3>
                </div> -->
                
            <!-- end nominee shareholder -->
        </div>
    </div>
</template>

<script>
import {
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BAvatar,
    BButton,
} from "bootstrap-vue";
import { SHAREHOLDER } from "@/constants/config";

export default {
    components: {
        BDropdown,
        BDropdownItem,
        BDropdownText,
        BAvatar,
        BButton,
    },

    props: {
        hasNomineeDirector: {
            type: Boolean,
            default: false,
        },

        generatePoa: {
            type: Boolean,
            default: false,
        },

        shareholdersList: {
            type: Object,
            required: true,
        },

        shareholderBluePrint: {
            type: Object,
            required: true,
        },

        isShareholderFull: {
            type: Boolean,
            required: true,
        },

        isFetchingData: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        openCreateShareholderForm(shareholder = this.shareholderBluePrint) {
            this.$emit("createShareholder", shareholder);
        },

        openCreateNomineeShareholderForm() {
            this.$emit('createNomineeShareholder');
        },

        totalStepsOf(shareholder) {
            if (shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE)
            {
                if (! this.hasNomineeDirector && ! this.generatePoa)
                {
                    /*
                       IGNORE_FIELD_1
                       --------------
                        // _id, secondaryCorporateRepresentativeName, secondaryCorporateRepresentativeAddress, address - 4
                        // poa person one (name, email), poa person two(name, email), POAAuthorizedPersonType, hasSecondPOA - 6
                        // nationality or country, idType, reference_id - 3
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        // ignore sourceOfFunds, sourceOfWealths, otherSource, otherWealth, generateDuediligence - 5
                    */

                    if(shareholder.isNomineeShareholder) {
                        if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                            // IGNORE_FIELD_1 and 12 nominee shareholder fields
                            // (isNomineeShareholder, isNewNominator, nominatorName, nominatorAlias, nominatorEmail, cessationDate, 
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark,)
                            if(shareholder.isNewNominator)
                                return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 12 + 2 + 5);

                            // IGNORE_FIELD_1, 17 nominee shareholder fields
                            // (isNomineeShareholder, isNewNominator, newNominatorName, cessationDate, nominatorEmail,  
                            // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark 
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar,
                            // nominatorAddress)
                            return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 17 + 2 + 5);
                        }

                        // IGNORE_FIELD_1  and 10 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                        // nominatorDOB, nominatorIdType, NominatorNationality, remark,)
                        if(shareholder.isNewNominator)
                            return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 10 + 2 + 5);

                        // IGNORE_FIELD_1 AND  11 nominee shareholder field
                        // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                        // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress )
                        return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 12 + 2 + 5);
                    }

                    // IGNORE_FIELD_1 and remove 20 nominee shareholder fields
                    return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 20 + 2 + 5);
                }

                // SHAREHOLDER TYPE CORPORATE AND HAS NOMINEE DIRECTOR AND NOMINEE SHAREHOLDER
                /* 
                    IGNORE_FIELDS_2
                    ---------------
                    // _id, secondaryCorpRepName, secondaryCorpRepAdd, address for corporate type cases - 4
                    // nationality or country, idType, reference_id - 3
                    // ignore dateOfExpiry and nominator dateOfExpiry
                    // ignore sourceOfFunds, sourceOfWealths, otherSource, otherWealth, generateDuediligence - 5
                */

                if(shareholder.isNomineeShareholder) {
                    if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                        // has poa
                        if(this.generatePoa) {
                            // IGNORE_FIELDS_2 and 12 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail,   
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark )
                            // IGNORE SECOND POA FIELDS + 4
                            if(shareholder.isNewNominator) 
                                return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 12 + 2 + 4 + 5);

                            // IGNORE_FIELDS_2 and 17 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                            //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                            //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                            // nominatorAddress )
                            // IGNORE SECOND POA FIELDS + 4
                            return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 17 + 2 + 4 + 5);
                        }
                        // has not poa
                        if(! this.generatePoa) {
                            // ignore 6 poa fields
                            // IGNORE_FIELDS_2 and 12 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail,   
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark )
                            if(shareholder.isNewNominator) 
                                return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 12 + 2 + 5);

                            // IGNORE_FIELDS_2 and 17 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                            //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                            //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                            // nominatorAddress )
                            return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 17 + 2 + 5);
                        }
                    }
                    
                    // CORPORATE SHAREHOLDER AND HAS POA FIELDS
                    if(this.generatePoa) {
                        // IGNORE_FIELDS_2 and 10 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                        // nominatorDOB, nominatorIdType, NominatorNationality, remark,)
                        // IGNORE SECOND POA FIELDS + 4
                        if(shareholder.isNewNominator)
                            return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 10 + 2 + 4 + 5);
                    
                        // IGNORE_FIELDS_2 and 12 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                        // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress)
                        // IGNORE SECOND POA FIELDS + 4
                        return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 12 + 2 + 4 + 5);
                    }

                    if(! this.generatePoa) {
                        // IGNORE POA FIELDS - 6
                        // IGNORE_FIELDS_2 and 10 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                        // nominatorDOB, nominatorIdType, NominatorNationality, remark,)
                        if(shareholder.isNewNominator)
                            return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 10 + 2 + 5);
                    
                        // IGNORE POA FIELDS - 6
                        // IGNORE_FIELDS_2 and 12 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                        // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress)
                        return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 12 + 2 + 5);
                    }
                }
                 
                if(this.generatePoa)
                    // IGNORE_FIELDS_2 and 10 nominee shareholder fields 20 nominee shareholder fields
                    // IGNORE SECOND POA FIELDS + 4
                    return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 20 + 2 + 4 + 5);
                // ELSE IGNORE POA FIELDS - 6
                return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 20 + 2 + 5);

            }

            // SHAREHOLDER TYPE INDIVIDUAL
            /* 
                IGNORE_FIELD_3
                --------------
                // _id, primaryCorpRepName, primaryCorpRepAddress, secondaryCorpRepName, secondaryCorpRepAddress - 5
                // poa person one(name, email),poa person two(name, email), POAAuthorizedPersonType, hasSecondPOA - 6
                // nationality or country, reference_id - 2
                // ignore sourceOfFunds, sourceOfWealths, otherSource, otherWealth, generateDuediligence - 5
            */

            if(shareholder.isNomineeShareholder) {
                if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                    // IGNORE_FIELD_3 and 12 nominee shareholder fields
                    // (isNomineeShareholder, isNewNominator, nominatorName, nominatorAlias, nominatorEmail, cessationDate, 
                    // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark,)
                    if(shareholder.isNewNominator)
                        return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 12 + 2 + 5);
                    
                    // IGNORE_FIELD_3 and 17 nominee shareholder fields
                    // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                    //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                    //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                    // nominatorAddress)
                    return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 17 + 2 + 5);
                }  

                // IGNORE_FIELD_3 and 10 nominee shareholder fields
                // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                // nominatorDOB, nominatorIdType, NominatorNationality, remark,) 
                if(shareholder.isNewNominator)
                    return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 10 + 2 + 5);

                // IGNORE_FIELD_3 and 12 nominee shareholder fields
                // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress) 
                return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 12 + 2 + 5);
            } 
            // IGNORE_FIELD_3 and 20 nominee shareholder fields
            return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 20 + 2 + 5);
        },

        getCompletedStepsOf(shareholder) {
            /*
            ** shareholder source of funds value is array
            ** it assume empty array have value, 
            ** so need to reduce manually after counting depend on shareholder source of funds value existing
            */

            // ignore _id, and address, secondary name and secondary address, otherSource for corporate type cases
            if (shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE)
            {
                if (! this.hasNomineeDirector && ! this.generatePoa)
                {
                   
                    // ignore _id, secondaryCorpRepName, secondaryCorpRepAdd, address for corporate type cases,
                    // poa person one(name, email),poa person two(name, email)

                    if(shareholder.isNomineeShareholder) {
                        // individual nominator
                        if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                            if(shareholder.isNewNominator) 
                                return (
                                    Object.keys(this.shareholderBluePrint).filter( 
                                        key => !! shareholder[key] &&
                                        ! key.includes("secondaryCorporateRepresentative") &&
                                        ! key.includes("idType") &&
                                        ! key.includes("dateOfExpiry") &&
                                        key !== "address" &&
                                        ! key.includes("POA") &&

                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        ! key.includes("referenceId") &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('remark') &&
                                        // ignore new nominator field
                                        !key.includes('nominatorEmail') &&
                                        !key.includes('nominatorName')

                                    ).length - 1
                                );

                            return (
                                Object.keys(this.shareholderBluePrint).filter( 
                                    key => !! shareholder[key] &&
                                    ! key.includes("secondaryCorporateRepresentative") &&
                                    ! key.includes("idType") &&
                                    ! key.includes("dateOfExpiry") &&
                                    key !== "address" &&
                                    ! key.includes("POA") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    ! key.includes("referenceId") &&
                                    // exclude nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes('nominatorDateOfExpiry') &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorUen') &&
                                    !key.includes('nominatorLegalForm') &&
                                    !key.includes('nominatorStatue') &&
                                    !key.includes('nominatorRegistrar') &&
                                    !key.includes('nominatorJurisdiction') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail')
                                ).length - 1
                            );
                        }
                        // corporate nominator
                        if(shareholder.isNewNominator) 
                            return (
                                Object.keys(this.shareholderBluePrint).filter( 
                                    key => !! shareholder[key] &&
                                        ! key.includes("secondaryCorporateRepresentative") &&
                                        ! key.includes("idType") &&
                                        ! key.includes("dateOfExpiry") &&
                                        key !== "address" &&
                                        ! key.includes("POA") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        ! key.includes("referenceId") &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorName') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('nominatorEmail')

                                ).length - 1
                            );
                        return (
                            Object.keys(this.shareholderBluePrint).filter( 
                                key => !! shareholder[key] &&
                                    ! key.includes("secondaryCorporateRepresentative") &&
                                    ! key.includes("idType") &&
                                    ! key.includes("dateOfExpiry") &&
                                    key !== "address" &&
                                    ! key.includes("POA") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    ! key.includes("referenceId") &&
                                    // exclude nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes('nominatorDateOfExpiry') &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail')
                            ).length - 1
                        );
                    }
                    // if not nominee shareholder
                    return (
                        Object.keys(this.shareholderBluePrint).filter( 
                            key => !! shareholder[key] &&
                                ! key.includes("secondaryCorporateRepresentative") &&
                                ! key.includes("idType") &&
                                ! key.includes("dateOfExpiry") &&
                                key !== "address" &&
                                ! key.includes("POA") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                ! key.includes("referenceId") &&
                                // exclude nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes('nominatorDateOfExpiry') &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorType') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('appointmentDate') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorNRIC') &&
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorAddress') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorName') &&
                                ! key.includes('newNominatorName') &&
                                ! key.includes('nominatorEmail')
                        ).length - 1
                    );
                }
                
                if(shareholder.isNomineeShareholder) {
                    // individual nominator 
                    if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                        // has poa
                        if(this.generatePoa) {
                            if(shareholder.isNewNominator) 
                                return (
                                    Object.keys(this.shareholderBluePrint).filter( 
                                        key => !! shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('remark') &&
                                        // ignore new nominator field
                                        !key.includes('nominatorEmail') &&
                                        !key.includes('nominatorName') &&
                                        // ignore second poa field
                                        !key.includes('POAAuthorizePersonTwoName') &&
                                        !key.includes('POAAuthorizePersonTwoEmail') &&
                                        !key.includes('POAAuthorizedPersonType') &&
                                        !key.includes('hasSecondPOA') 
                                    ).length - 1
                                );
                            return (
                                Object.keys(this.shareholderBluePrint).filter( 
                                    key => !! shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorNRIC') &&
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorAddress') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('newNominatorName') &&
                                        ! key.includes('nominatorEmail') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        // ignore second poa fields
                                        !key.includes('POAAuthorizePersonTwoName') &&
                                        !key.includes('POAAuthorizePersonTwoEmail') &&
                                        !key.includes('POAAuthorizedPersonType') &&
                                        !key.includes('hasSecondPOA') 
                                ).length - 1
                            );
                        }
                        // not has poa
                        if(! this.generatePoa) { 
                            if(shareholder.isNewNominator) 
                                return (
                                    Object.keys(this.shareholderBluePrint).filter( 
                                        key => !! shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        !key.includes("POA") &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('remark') &&
                                        // ignore new nominator field
                                        !key.includes('nominatorEmail') &&
                                        !key.includes('nominatorName')

                                    ).length - 1
                                );
                            return (
                                Object.keys(this.shareholderBluePrint).filter( 
                                    key => !! shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        ! key.includes("POA") &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorNRIC') &&
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorAddress') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('newNominatorName') &&
                                        ! key.includes('nominatorEmail') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction')
                                ).length - 1
                            );
                        }
                    }

                    // hos poa
                    if(this.generatePoa) {
                        if(shareholder.isNewNominator) 
                            return (
                                Object.keys(this.shareholderBluePrint).filter( 
                                    key => !! shareholder[key] &&
                                        ! key.includes("secondaryCorporateRepresentative") &&
                                        ! key.includes("idType") &&
                                        ! key.includes("dateOfExpiry") &&
                                        key !== "address" &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        ! key.includes("referenceId") &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        ! key.includes('cessationDate') &&
                                        ! key.includes('nominatorAlias') &&
                                        ! key.includes('remark') &&
                                        // ignore new nominator field
                                        ! key.includes('nominatorEmail') &&
                                        ! key.includes('nominatorName') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('nominatorDOB') &&
                                        // ignore second poa fields
                                        ! key.includes('POAAuthorizePersonTwoName') &&
                                        ! key.includes('POAAuthorizePersonTwoEmail') &&
                                        ! key.includes('POAAuthorizedPersonType') &&
                                        ! key.includes('hasSecondPOA')
                                ).length - 1
                            );
                    
                        return (
                            Object.keys(this.shareholderBluePrint).filter( 
                                key => !! shareholder[key] &&
                                    ! key.includes("secondaryCorporateRepresentative") &&
                                    ! key.includes("idType") &&
                                    ! key.includes("dateOfExpiry") &&
                                    key !== "address" &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    ! key.includes("referenceId") &&
                                    // exclude nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes('nominatorDateOfExpiry') &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail') &&
                                    // ignore second poa fields
                                    ! key.includes('POAAuthorizePersonTwoName') &&
                                    ! key.includes('POAAuthorizePersonTwoEmail') &&
                                    ! key.includes('POAAuthorizedPersonType') &&
                                    ! key.includes('hasSecondPOA')
                            ).length - 1
                        );
                    }

                    // has not poa
                    if(! this.generatePoa) {
                        // corporate nominator
                        if(shareholder.isNewNominator) 
                            return (
                                Object.keys(this.shareholderBluePrint).filter( 
                                    key => !! shareholder[key] &&
                                        ! key.includes("secondaryCorporateRepresentative") &&
                                        ! key.includes("idType") &&
                                        ! key.includes("dateOfExpiry") &&
                                        key !== "address" &&
                                        ! key.includes("POA") &&
                                       
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        ! key.includes("referenceId") &&
                                        // exclude nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('nominatorDateOfExpiry') &&
                                        !key.includes('isNewNominator') &&
                                        ! key.includes('cessationDate') &&
                                        ! key.includes('nominatorAlias') &&
                                        ! key.includes('remark') &&
                                        // ignore new nominator field
                                        ! key.includes('nominatorEmail') &&
                                        ! key.includes('nominatorName') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('nominatorDOB')
                                ).length - 1
                            );
                    
                        return (
                            Object.keys(this.shareholderBluePrint).filter( 
                                key => !! shareholder[key] &&
                                    ! key.includes("secondaryCorporateRepresentative") &&
                                    ! key.includes("idType") &&
                                    ! key.includes("dateOfExpiry") &&
                                    key !== "address" &&
                                    ! key.includes("POA") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    ! key.includes("referenceId") &&
                                    // exclude nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes('nominatorDateOfExpiry') &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail')
                            ).length - 1
                        );
                    }
                    
                }
                
                if(this.generatePoa)
                    return (
                        Object.keys(this.shareholderBluePrint).filter( 
                            key => !! shareholder[key] &&
                                ! key.includes("secondaryCorporateRepresentative") &&
                                ! key.includes("idType") &&
                                ! key.includes("dateOfExpiry") &&
                                key !== "address" &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                ! key.includes("referenceId") &&
                                // exclude nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes('nominatorDateOfExpiry') &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorType') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('appointmentDate') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorNRIC') &&
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorAddress') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorName') &&
                                ! key.includes('newNominatorName') &&
                                ! key.includes('nominatorEmail') &&
                                // ignore second poa fields
                                ! key.includes('POAAuthorizePersonTwoName') &&
                                ! key.includes('POAAuthorizePersonTwoEmail') &&
                                ! key.includes('POAAuthorizedPersonType') &&
                                ! key.includes('hasSecondPOA')
                        ).length - 1
                    );
                return (
                    Object.keys(this.shareholderBluePrint).filter( 
                        key => !! shareholder[key] &&
                                ! key.includes("secondaryCorporateRepresentative") &&
                                ! key.includes("idType") &&
                                ! key.includes("dateOfExpiry") &&
                                key !== "address" &&
                                ! key.includes("POA") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                ! key.includes("referenceId") &&
                                // exclude nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes('nominatorDateOfExpiry') &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorType') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('appointmentDate') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorNRIC') &&
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorAddress') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorName') &&
                                ! key.includes('newNominatorName') &&
                                ! key.includes('nominatorEmail') &&
                                // ignore second poa fields
                                ! key.includes('POAAuthorizePersonTwoName') &&
                                ! key.includes('POAAuthorizePersonTwoEmail') &&
                                ! key.includes('POAAuthorizedPersonType') &&
                                ! key.includes('hasSecondPOA')
                    ).length - 1
                );
            }
            
            if(shareholder.isNomineeShareholder) {
                // individual nominator
                if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                    if(shareholder.isNewNominator)
                        // ignore _id, primary corp name, primary corp address, secondary corp name, secondary corp address for individual case
                        // ignore poa fields 6
                        return (
                            Object.keys(this.shareholderBluePrint).filter(
                                key =>
                                    !!shareholder[key] && 
                                    !key.includes("CorporateRepresentative") &&
                                    !key.includes("POA") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    !key.includes("referenceId") &&
                                    !key.includes('dateOfExpiry') &&
                                    // exclude nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes('nominatorDateOfExpiry') &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('nominatorUen') &&
                                    !key.includes('nominatorLegalForm') &&
                                    !key.includes('nominatorStatue') &&
                                    !key.includes('nominatorRegistrar') &&
                                    !key.includes('nominatorJurisdiction') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('remark') &&
                                    // ignore new nominator field
                                    !key.includes('nominatorEmail') &&
                                    !key.includes('nominatorName')
                            ).length - 1
                        );
                    
                    // ignore _id, primary corp name, primary corp address, secondary corp name, secondary corp address for individual case
                    // ignore poa fields 6
                    
                    return (
                        Object.keys(this.shareholderBluePrint).filter(
                            key =>
                                !!shareholder[key] && 
                                ! key.includes("CorporateRepresentative") &&
                                ! key.includes("POA") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                ! key.includes("referenceId") &&
                                !key.includes('dateOfExpiry') &&
                                // exclude nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes('nominatorDateOfExpiry') &&
                                !key.includes('isNewNominator') &&
                                !key.includes('cessationDate') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('remark') &&
                                // ignore new nominator field
                                !key.includes('nominatorEmail') &&
                                !key.includes('newNominatorName') &&
                                !key.includes('nominatorIdType') &&
                                !key.includes('nominatorNationality') &&
                                !key.includes('nominatorDOB') &&
                                !key.includes('nominatorNRIC') &&
                                !key.includes('nominatorAddress') 
                        ).length - 1
                    );
                }
                
                // corporate nominator
                if(shareholder.isNewNominator)
                    // ignore _id, primary corp name, primary corp address, secondary corp name, secondary corp address for individual case
                    // ignore poa fields 6
                    return (
                        Object.keys(this.shareholderBluePrint).filter(
                            key =>
                                !!shareholder[key] && 
                                !key.includes("CorporateRepresentative") &&
                                !key.includes("POA") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                !key.includes("referenceId") &&
                                !key.includes('dateOfExpiry') &&
                                // exclude nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes('nominatorDateOfExpiry') &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorEmail') && 
                                ! key.includes('nominatorName') 
                        ).length - 1
                    );
                // ignore _id, primary corp name, primary corp address, secondary corp name, secondary corp address for individual case
                // ignore poa fields 6
                return (
                    Object.keys(this.shareholderBluePrint).filter(
                        key =>
                            !!shareholder[key] && 
                        !key.includes("CorporateRepresentative") &&
                        !key.includes("POA") &&
                        
                        // sow and sof field
                        !key.includes("generateDueDiligence") &&
                        !key.includes("sourcesOfFunds") &&
                        !key.includes("otherSource") &&
                        !key.includes("sourceOfWealth") &&
                        !key.includes("otherWealth") &&

                        !key.includes("referenceId") &&
                        !key.includes('dateOfExpiry') &&
                        // exclude nominee shareholder fields
                        !key.includes('isNomineeShareholder') &&
                        !key.includes('nominatorDateOfExpiry') &&
                        !key.includes('isNewNominator') &&
                        !key.includes('nominatorAlias') &&
                        !key.includes('cessationDate') &&
                        !key.includes('remark') &&
                        // exclude new nominator fields
                        ! key.includes('nominatorNRIC') &&
                        ! key.includes('nominatorDOB') &&
                        ! key.includes('nominatorAddress') &&
                        ! key.includes('nominatorIdType') &&
                        ! key.includes('nominatorNationality') &&
                        ! key.includes('newNominatorName') &&
                        ! key.includes('nominatorEmail')
                    ).length - 1
                );
            }

            // shareholder is individual and not nominee shareholder
            // ignore _id, primary corp name, primary corp address, secondary corp name, secondary corp address for individual case
            // ignore poa fields 6
            return (
                Object.keys(this.shareholderBluePrint).filter(
                    key =>
                        !!shareholder[key] && 
                        !key.includes("CorporateRepresentative") &&
                        !key.includes("POA") &&
                        
                        // sow and sof field
                        !key.includes("generateDueDiligence") &&
                        !key.includes("sourcesOfFunds") &&
                        !key.includes("otherSource") &&
                        !key.includes("sourceOfWealth") &&
                        !key.includes("otherWealth") &&

                        !key.includes("referenceId") &&
                        !key.includes('dateOfExpiry') &&
                        // exclude nominee shareholder fields
                        !key.includes('isNomineeShareholder') &&
                        !key.includes('nominatorDateOfExpiry') &&
                        !key.includes('isNewNominator') &&
                        !key.includes('nominatorType') &&
                        !key.includes('nominatorUen') &&
                        !key.includes('nominatorLegalForm') &&
                        !key.includes('nominatorStatue') &&
                        !key.includes('nominatorRegistrar') &&
                        !key.includes('nominatorJurisdiction') &&
                        !key.includes('nominatorAlias') &&
                        !key.includes('appointmentDate') &&
                        !key.includes('cessationDate') &&
                        !key.includes('remark') &&
                        // exclude new nominator fields
                        ! key.includes('nominatorNRIC') &&
                        ! key.includes('nominatorDOB') &&
                        ! key.includes('nominatorAddress') &&
                        ! key.includes('nominatorIdType') &&
                        ! key.includes('nominatorNationality') &&
                        ! key.includes('nominatorName') &&
                        ! key.includes('newNominatorName') &&
                        ! key.includes('nominatorEmail')
                ).length - 1
            );
        },
    },
};
</script>
